<template>
  <component :is="resolveLayoutVariant" :class="`skin-variant--${appSkinVariant}`">
    <transition :name="appRouteTransition" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </component>
</template>

<script>
import { getCurrentInstance, computed } from "@vue/composition-api";
import { useRouter } from "@core/utils";
import { useAppStore } from "@/stores/app";

import { provideToast } from "vue-toastification/composition";
import "vue-toastification/dist/index.css";

import LayoutBlank from "@/layouts/variants/blank/LayoutBlank.vue";
import LayoutCallCenter from "@/layouts/variants/call-center/LayoutCallCenter.vue";
import LayoutContentVerticalNav from "@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue";

import useAppConfig from "@core/@app-config/useAppConfig";

export default {
  components: {
    LayoutCallCenter,
    LayoutContentVerticalNav,
    LayoutBlank,
  },
  setup() {
    const vm = getCurrentInstance().proxy;

    const { route } = useRouter();
    const { appSkinVariant, appRouteTransition } = useAppConfig();
    const appStore = useAppStore();

    const userData = JSON.parse(localStorage.getItem("userData"));
    
    if (userData) {
      appStore.userData = userData;
      appStore.userRole = userData.role;
    }

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === "blank") return "layout-blank";
      if (route.value.meta.layout === "content") {
        if (vm.$ability.can("create", "callCenter")) {
          return "layout-call-center";
        } else {
          return `layout-content-vertical-nav`;
        }
      }

      return null;
    });

    provideToast({ timeout: 2500, position: "bottom-right" });

    return {
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
    };
  },
};
</script>
